import { type CSSProperties, useEffect, useReducer } from 'react';
import { createPortal } from 'react-dom';
import CopyToClipboard from './CopyToClipboard/CopyToClipboard';

export const CopyToClipboardMacro = ({ style, query }: { style?: CSSProperties; query: string }) => {
  const [, forceUpdate] = useReducer((x: number) => x + 1, 0);
  const nodes = Array.from(document.querySelectorAll(query));
  useEffect(() => {
    const components = document.querySelectorAll(query);
    if (nodes.length === 0 && components.length > 0) forceUpdate();
  });

  const text = nodes.map((o) => o.getAttribute('data-copy-text'));
  if (!nodes.length) return null;
  return nodes.map((node, i) =>
    createPortal(
      <div>
        <CopyToClipboard
          text={text[i] ?? ''}
          containerStyle={{
            right: 5,
            top: 6,
            position: 'absolute',
            ...style,
          }}
        />
      </div>,
      node
    )
  );
};
